<template>
  <div class="container-fluid p-0">
  <div class="video-background-container">
    <b-carousel id="carousel-no-animation" class="shadow-lg rounded-2" controls fade indicators>
      <b-carousel-slide :img-src="getFiles('1.jpg')"></b-carousel-slide>
      <b-carousel-slide :img-src="getFiles('2.jpg')"></b-carousel-slide>
      <b-carousel-slide :img-src="getFiles('3.jpg')"></b-carousel-slide>
      <b-carousel-slide :img-src="getFiles('4.jpg')"></b-carousel-slide>
    </b-carousel>    
  <div class="overlay"></div>
  <div class="content">
    <header id="page-topbar" style="background-color:rgba(100, 100, 100, 0.4)">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box me-5">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm"><img src="@/assets/images/logo2.jpg" height="30px" style="border-radius: 1%;"/></span>
            <span class="logo-lg"><img src="@/assets/images/logo2.jpg" height="50px" style="border-radius: 1%;"/></span>
          </router-link>
        </div>

        <div class="d-none d-xl-inline-block">
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content><b-button class="btn-sm" variant="primary"> Quick Links <i class="mdi mdi-chevron-down"></i></b-button>
          </template>
            <a target="_blank" href="https://fdc.ug/leadership/" class="dropdown-item text-primary"><i class="fas fa-user-tie font-size-16 align-middle me-1 text-primary"></i> Leadership</a>
            <a target="_blank" href="https://fdc.ug/parliament/" class="dropdown-item text-primary"><i class="fas fa-hospital font-size-16 align-middle me-1 text-primary"></i> Parliament</a>
            <a target="_blank" href="https://fdc.ug/womens-league/" class="dropdown-item text-primary"><i class="bx bx-female font-size-16 align-middle me-1 text-primary"></i> Women's League</a>
            <a target="_blank" href="https://fdc.ug/youth-league/" class="dropdown-item text-primary"><i class="fas fa-walking font-size-16 align-middle me-1 text-primary"></i> Youth League</a>
          </b-dropdown>
      </div>
      </div>

      <div class="d-flex">
        <!-- <button id="toggle" type="button" class="btn btn-sm me-2 font-size-16 d-lg-none header-item" @click="toggleMenu"><i class="fa fa-fw fa-bars text-success"></i></button> -->
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <b-button variant="primary" size="sm"><i class="mdi mdi-google-translate me-1"></i> Translate </b-button>
          </template>
          <Translator :countries="arrayOfCountries" @on-country-click="customEvent" />
        </b-dropdown>
        <span v-if="memberData==null">
          <a href="/login" class="header-item"><button type="button" class="btn pe-2"><i class="mdi mdi-account-circle text-white mdi-36px"></i></button><span class="h6 d-none d-xl-inline-block text-white">Log in / Become a Member</span></a>
        </span>
        <span v-else>
          <b-dropdown right variant="black" toggle-class="header-item">
            <template v-slot:button-content>
              <img class="rounded-circle header-profile-user" src="@/assets/images/user.png" />
              <span class="d-none d-xl-inline-block h6 text-white ms-1">{{ memberData.first_name.charAt(0) }} {{ memberData.last_name.charAt(0) }}</span>
              <i class="mdi mdi-chevron-down text-white d-none d-xl-inline-block"></i>
            </template>
             <router-link to="/home" class="fw-medium dropdown-item text-success"><i class="mdi mdi-account me-1"></i> My Account</router-link> 
            <a href="/logout" class="dropdown-item text-success"><i class="bx bx-power-off font-size-16 align-middle me-1 text-success"></i> logout</a>
          </b-dropdown>
        </span>
      </div>
    </div>
    </header>
  </div>
  </div>

    <div class="py-5" style="background-color:#E6FDFF">
    <div class="container">
        <h3 class="text-primary"><b>Forum for Democratic Change 🌟</b></h3>
        <p style="font-size: 13px;">
          The Forum for Democratic Change (FDC), founded on December 16, 2004, is a leading opposition political party in Uganda dedicated to social, economic, and political transformation. It emerged from the Reform Agenda, uniting various opposition groups. Initially led by Dr. Kizza Besigye, the FDC gained significant support, securing 37% of the vote in the 2006 presidential election. Its mission is to foster unity, sustainable peace, and accountable democratic institutions. The FDC’s policy agenda emphasizes inclusive economic growth, job creation, and improved public services. It advocates for constitutionalism, regional integration, and the rights of marginalized groups through affirmative action. Headquartered in Najjanankumbi, Kampala, the FDC remains a key player in Ugandan politics. The party aims to empower citizens to shape their own destiny. It views leadership as a service, prioritizing dignity and equal opportunity for all. The FDC continues to champion democratic governance in Uganda.
        </p>
        <router-link tag="a" to="/login" class="btn btn-primary w-10 btn-sm" >Become a Member</router-link>
        <a target="_blank" href="https://flutterwave.com/donate/qud1kb3qld68" class="btn btn-outline-primary w-10 btn-sm ms-2"> <i class="mdi mdi-store"></i> Donate</a>
        
        <br><br><br>
        <h4 style="color: black;" class="d-flex justify-content-between"><span>Recent News</span> 
        <router-link tag="a" to="/news" class="btn btn-sm btn-outline-primary w-10"> <i class="mdi mdi-filter"></i> View All</router-link> </h4>
        <div class="row">
          <div v-for="posts in this.limitedNews" :key="posts.id" class="col-md-4 col-6 mb-2">
            <router-link :to="{ path: '/article', query: { id: posts.id }}">
              <div class="shadow-lg" style="border-radius: 2px 20px;">
                <div class="p-1">
                  <div style=" display: flex; justify-content: center; align-items: center; overflow: hidden; border-radius: 2px 20px;">
                    <img :src="posts['yoast_head_json']['og_image'][0]['url']" class="img-fluid rounded-3 shadow-lg"/>
                  </div>
                <div class="p-3">
                  <b class="h6" style="color: black;">{{posts.title.rendered}}</b><br>
                  <span><i class="fas fa-calendar-alt"></i> {{ new Date(posts.date).toLocaleDateString('en-US', options)}} </span>
                </div>
              </div>
              </div>
            </router-link>
          </div>
        </div>

      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import { Translator } from 'vue-google-translate';
import appConfig from "@/app.config";
import Footer from "@/components/footer";
// import { LMap, LTileLayer, LMarker,LPopup } from 'vue2-leaflet';
import { districtMethods, districtComputed } from "@/state/helpers";

export default {
  page: {
    title: "Home",
    meta: [{name: "description",content: appConfig.description}],
  },
  components: { Translator, Footer,
    // LMap, LTileLayer, LMarker, LPopup
   },
  data() {
    return {      
      memberData: JSON.parse(localStorage.getItem("member")),
      phone: localStorage.getItem("phone"),
      arrayOfCountries: [
        {  code: 'en|en',  title: 'English',  },
        {  code: 'en|fr',  title: 'French',  },
        {  code: 'en|ar',  title: 'Arabic',  },
        {  code: 'en|es',  title: 'Spanish',  },
        {  code: 'en|de',  title: 'German',  },      
        {  code: 'en|sw',  flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ke.svg',  title: 'Swahili',},
        {  code: 'en|lg',  flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ug.svg',  title: 'Luganda',},
        {  code: 'en|rw',  flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/rw.svg',  title: 'Kinyarwanda',},
      ],
        
      // url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      // center: [JSON.parse(localStorage.getItem("coordinates")).lat, JSON.parse(localStorage.getItem("coordinates")).lng],
      markers: [], value:2,
      news: [],
      loading: false,
      options : { weekday: "long", year: "numeric", month: "long", day: "numeric",},

    };
  },
  created() {
    this.fetchNews();
    this.fetchDistricts();
  },
  methods: {
    ...districtMethods,
    customEvent() {
      this.$emit('on-country-click');
    },
    filterProduct(e) {
      const search = e.target.value;
      this.filterProducts({search:search});
    },

    async fetchNews() {
      this.loading = true
      try {
        const response = await fetch('https://fdc.ug/wp-json/wp/v2/posts', {
          method: 'GET', headers: { 'Content-Type': 'application/json'  }
        })        
        const data = await response.json()
        this.news = data
      } catch (error) {
        this.error = error.message
        alert('Error fetching posts:', error)
      } finally {
        this.loading = false
      }
    },

  
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"pics/"+name;
      return imagelink;
    },
    
    async fetchMapMarkers(){
      let url = "/fetchmapmarkers";
      await axios.get(url).then((response) => {
      if (response.status == 200) {
        this.markers=response.data.markers;
      }
    })
    },
    getProduct(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"products/"+name;
      return imagelink;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  },
  computed: {
    ...districtComputed,
    limitedNews() {return this.news.slice(0, 6);},
  }
}; 
</script>

<style scoped>
.card img {
  width: 100%;
  height: auto;
  transition: transform 0.3s ease-in-out;
}
.card:hover img {
  transform: scale(1.1);
}
.video-background-container {
  position: relative;
  width: 100%; /* Full viewport height */
  overflow: hidden;
}
.video-background-container video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1; /* Behind other content */
  transform: translate(-50%, -50%); /* Center the video */
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.50); /* Black with 50% opacity */
  z-index: 0; /* On top of the video, behind the content */
}
.content { z-index: 1; }
.typing-effect {
    white-space: nowrap;
    overflow: hidden;
    border-right: 2px solid; /* Creates a cursor-like effect */
    /* width: 0; */
    animation: delete 10s steps(110, end), rewrite 8s steps(110, end) 10s forwards;
}

@keyframes delete { 0% {  width: 55ch; } 100% {   width: 0ch;  } }
@keyframes rewrite {  0% {  width: 0ch; }  100% {   width: 55ch;}  }
</style>
